
export default {
    state: {
        clickList: {}
    },
    getters: {
        clickList: state => state.clickList
    },
    mutations: {
        updateClickList(state, data) {
            state.clickList = data;
        }
    }
};
